/*
Copyright (C) 2026  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import Api from "@src/utils/ApiCaller";
import configLoader from "@src/utils/Config";

export type AuditRecord = {
  id: number;
  created_at: string;
  kind: "api" | "execution" | "operation";
  user_id: string | null;
  user_name: string | null;
  project_id: string | null;
  request_id: string | null;
  method: string | null;
  path: string | null;
  action: string | null;
  resource_type: string | null;
  resource_id: string | null;
  name: string | null;
  status: string | null;
  status_code: number | null;
  details: any;
};

export type AuditFilters = {
  kind?: string;
  status?: string;
  search?: string;
  since?: string;
  until?: string;
  limit?: number;
};

class AuditSource {
  async list(filters: AuditFilters): Promise<AuditRecord[]> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        params.set(k, String(v));
      }
    });
    const response = await Api.send({
      url: `${configLoader.config.servicesUrls.coriolis}/${Api.projectId}/audit?${params.toString()}`,
    });
    return response.data.audit;
  }
}

export default new AuditSource();
